export const DASHBOARD_STAT_CARD_WAVE_PATH =
  'M-70.7694 53.5961L-38.8027 47.4924C-34.0032 46.576 -29.0343 47.4483 -24.8339 49.9446L7.78546 69.3303C12.3362 72.0348 17.7734 72.8248 22.9056 71.5272L69.5363 59.7374C74.7206 58.4267 80.2139 59.2466 84.7895 62.0142L105.849 74.7521C117.109 81.5623 129.601 86.0834 142.612 88.0562L195 96L140.679 125.755L-75.9993 102.656L-70.7694 53.5961Z'

export function getDashboardStatCardWaveFilterId(statId: string) {
  return `dashboard-stat-wave-filter-${statId}`
}
